import styled from 'vue-styled-components';

import theme from '@/config/theme';

export const Link = styled.a`
  color: ${theme.colors.gray5};
  font-size: ${theme.font.sizes.p2};

  &:hover {
    color: ${theme.colors.primaryLight};
  }
`;

export const Wrapper = styled.footer`
  bottom: 0;
  height: 66px;
  position: absolute;
  width: 100%;

  > div {
    align-items: center;
    border-top: 1px solid ${theme.colors.gray3};
    display: flex;
    gap: 24px;
    height: 100%;
    justify-content: flex-end;
  }
`;
